module.exports = __webpack_public_path__ + "img/Frame_14.e7db9ea4.png";